import React from 'react';

import PropTypes from 'prop-types';

import { PayPalButtons, usePayPalScriptReducer } from '@paypal/react-paypal-js';
import * as Sentry from '@sentry/react';
import { logInfo } from 'apps/auth/helpers/clientLogger';

import PayPalErrorModal from './PayPalErrorModal';

const PayPalButton = ({ popupRef = null, modalRef = null, statusPageHref, createOrder, style }) => {
    const [{ isRejected }] = usePayPalScriptReducer();

    if (isRejected) {
        if (__isDev__) {
            logInfo('SDK init was rejected');
        }
        popupRef.current?.close();
        modalRef?.current?.open(<PayPalErrorModal />);
    }

    const onCancel = () => {
        if (__isDev__) {
            logInfo('Transfer was cancelled');
        }
        popupRef.current?.close();
    };

    const onError = (err) => {
        if (__isDev__) {
            logInfo('PayPal SDK transfer error:', err);
        }
        popupRef.current?.close();
        modalRef?.current?.open(<PayPalErrorModal />);
        Sentry.captureMessage('PayPal SDK transfer error', {
            extra: {
                error: err,
            },
            level: 'error',
        });
    };

    const onApprove = (data) => {
        if (__isDev__) {
            logInfo('PayPal SDK transfer approved:', data);
        }
        window.location.href = statusPageHref;
    };

    return <PayPalButtons className={'paypal-button'} createOrder={createOrder} onApprove={onApprove} onCancel={onCancel} onError={onError} style={style} />;
};

PayPalButton.propTypes = {
    modalRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
    popupRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
    style: PropTypes.object.isRequired,
    createOrder: PropTypes.func.isRequired,
    className: PropTypes.string.isRequired,
    statusPageHref: PropTypes.string.isRequired,
};

export default PayPalButton;
